import { createSelector } from "reselect";

import { filterCreditRedeemCharges } from "@app/modules/checkout/utils/cart-v2";

import { getCartCharges } from "./state-accessors";

export const getRedeemedAmount = createSelector([getCartCharges], charges => {
  return filterCreditRedeemCharges(charges).reduce(
    (acc, charge) => acc + charge.amount,
    0
  );
});

export const hasRedeemed = createSelector(
  [getCartCharges],
  charges => filterCreditRedeemCharges(charges).length > 0
);
